/**
 * @generated SignedSource<<0823bf6d4c96a0330b2a00bc8a57f4e7>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate =
  {
    __typename?: "ConfluenceDate";
    value: string;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location =

    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_FooterComment
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location_InlineComment;
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by =

    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_Anonymous
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_KnownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_UnknownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by_User;
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version_by | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author =

    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_Anonymous
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_KnownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_UnknownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author_User;
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_body_DocumentBody =
  {
    __typename?: "DocumentBody";
    value: string;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_links_Map_LinkType_String =
  {
    __typename?: "Map_LinkType_String";
    webui: string | null;
    editui: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties =
  {
    __typename?: "InlineCommentResolveProperties";
    resolved: boolean;
    isDangling: boolean;
    resolvedFriendlyDate: string | null;
    resolvedTime: number | null;
    resolvedUser: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment =
  {
    __typename?: "FooterComment";
    type: string;
    commentResolveProperties: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment_commentResolveProperties_InlineCommentResolveProperties | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment =
  {
    __typename?: "InlineComment";
    inlineMarkerRef: string | null;
    inlineText: string | null;
    type: string;
    inlineResolveProperties: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment_inlineResolveProperties_InlineCommentResolveProperties | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location =

    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_FooterComment
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location_InlineComment;
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_permissions_CommentPermissions =
  {
    __typename?: "CommentPermissions";
    isEditable: boolean;
    isRemovable: boolean;
    isResolvable: boolean;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_KnownUser =
  {
    __typename?: "KnownUser";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_User =
  {
    __typename?: "User";
    displayName: string | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by =

    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_Anonymous
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_KnownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_UnknownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by_User;
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version =
  {
    __typename?: "Version";
    when: string | null;
    number: number | null;
    by: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version_by | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    path: string;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser =
  {
    __typename?: "UnknownUser";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous_profilePicture_Icon | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author =

    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_Anonymous
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_KnownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_UnknownUser
    | ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author_User;
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment =
  {
    __typename?: "Comment";
    id: string;
    contentStatus: string;
    createdAtNonLocalized: string;
    parentId: string | null;
    body: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_body_DocumentBody;
    createdAt: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate;
    links: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_links_Map_LinkType_String;
    location: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_location;
    permissions: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_permissions_CommentPermissions;
    version: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_version_Version;
    author: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment_author;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment =
  {
    __typename?: "Comment";
    id: string;
    contentStatus: string;
    createdAtNonLocalized: string;
    parentId: string | null;
    body: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_body_DocumentBody;
    createdAt: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_createdAt_ConfluenceDate;
    links: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_links_Map_LinkType_String;
    location: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_location;
    permissions: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_permissions_CommentPermissions;
    version: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_version_Version;
    author: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_author;
    replies: Array<ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment_replies_Comment | null>;
  };
export type ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList =
  {
    __typename?: "PaginatedCommentList";
    totalCount: number | null;
    nodes: Array<ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList_nodes_Comment | null> | null;
  };
export type ResolvedViewResolvedInlineCommentsQuery_Query = {
  __typename?: "Query";
  comments: ResolvedViewResolvedInlineCommentsQuery_comments_PaginatedCommentList | null;
};
export type ResolvedViewResolvedInlineCommentsQueryVariables = Exact<{
  pageId: Scalars["ID"]["input"];
  contentStatus?: InputMaybe<
    Array<GraphQLContentStatus> | GraphQLContentStatus
  >;
}>;
export type ResolvedViewResolvedInlineCommentsQuery =
  ResolvedViewResolvedInlineCommentsQuery_Query;
